import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { useTranslation } from "react-i18next"
import { analyticsAction } from "/src/utils/analytics"

/*const checkList = [
  "Perform automatic script breakdown.",
  "Create a shooting schedule.",
  "Export your results to Movie Magic Scheduling and Final Draft.",
  "Analyze your script for risks with the AI Script Analysis feature.",
]*/

function Cta({ slug = "main" }) {
  const { t } = useTranslation()

  return (
    <section>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative">
        <div className="pt-12 md:pt-20 border-t border-gray-800">
          <div
            className="max-w-3xl mx-auto text-center pb-12 md:pb-16"
            data-aos-id-cta
          >
            {/* Section header */}
            <h2
              className="h2 mb-4"
              data-aos="fade-up"
              data-aos-anchor="[data-aos-id-cta]"
            >
              {t("cta.title")}
            </h2>
            <p
              className="text-xl text-gray-400 mb-8 text-left md:text-center"
              data-aos="fade-up"
              data-aos-delay="200"
              data-aos-anchor="[data-aos-id-cta]"
            >
              {t("cta.subtitle")}
            </p>

            {/* CTA button */}
            <div
              className="flex justify-center mb-8"
              data-aos="fade-up"
              data-aos-delay="400"
              data-aos-anchor="[data-aos-id-cta]"
            >
              <a
                className="btn text-gray-800 bg-fOrange-900 hover:bg-fOrange-800"
                href={`https://app.filmustage.com/sign/up?fm_page=${slug}&fm_cta=cta_block`}
                onClick={async () =>
                  await analyticsAction("landing_sign_up_click")
                }
              >
                {t("cta.button")}
              </a>
            </div>

            {/* Check list
            <ul className="flex flex-wrap sm:justify-center text-lg text-gray-400 -mx-2 -my-1">
              {checkList.map((text, index) => (
                <li
                  className="flex text-left items-start mx-3 my-1"
                  data-aos="fade-up"
                  data-aos-delay={`${600 + 200 * index}`}
                  data-aos-anchor="[data-aos-id-cta]"
                  key={index}
                >
                  <svg
                    className="w-3 h-3 fill-current text-green-500 mr-2 mt-2 flex-shrink-0"
                    viewBox="0 0 12 12"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                  </svg>
                  <span>{text}</span>
                </li>
              ))}
            </ul>*/}

            <div
              data-aos="fade-up"
              data-aos-delay="1200"
              data-aos-anchor="[data-aos-id-cta]"
            >
              <StaticImage
                quality={90}
                className="mx-auto rounded-md max-w-3xl mt-2 shadow-2xl shadow-indigo-500/30"
                src="../images/film/how-new/cta.png"
                width={1440}
                height={737}
                alt="Relax!"
                placeholder="none"
                loading="eager"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Cta
